"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _SidebarProductHeading = _interopRequireDefault(require("./SidebarProductHeading"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "sidebar-product-heading": "DefaultTheme__sidebar-product-heading___nq3J5",
  "text": "DefaultTheme__text___cVj0Y",
  "icon": "DefaultTheme__icon___36JrF",
  "sidebarProductHeading": "DefaultTheme__sidebar-product-heading___nq3J5"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "sidebar-product-heading": "LumeTheme__sidebar-product-heading___1sWWP",
  "sidebarProductHeading": "LumeTheme__sidebar-product-heading___1sWWP"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  LumeTheme: LumeTheme
};
var ThemedSidebarProductHeading = (0, _reactCssThemr.themr)(_SidebarProductHeading["default"].displayName, themes.DefaultTheme)(_SidebarProductHeading["default"]);
ThemedSidebarProductHeading.displayName = _SidebarProductHeading["default"].displayName;
ThemedSidebarProductHeading.themes = themes;
var _default = exports["default"] = ThemedSidebarProductHeading;
//# sourceMappingURL=index.js.map